import { Confirmation, RouterContext } from '../../libs/gs-component-right-rail';
import React, { useContext } from 'react';

import { Maybe, useDeletePageMutation } from '../../generated/graphql';
import { deletePageUpdate } from '../ManagePagesRail/deletePageUpdate';

interface Props {
  pageId?: Maybe<number>;
  onClose: () => void;
}

export const ConfirmDelete: React.FC<Props> = ({ pageId, onClose }) => {
  const { goBack } = useContext(RouterContext);
  const [deletePage, { loading }] = useDeletePageMutation();

  const onDelete = async (): Promise<void> => {
    if (!pageId) {
      return;
    }

    await deletePage({
      variables: {
        id: pageId,
      },
      update(cache, { data }) {
        deletePageUpdate(cache, data);
      },
    });

    onClose();
  };

  return (
    <Confirmation
      data-testid="delete-confirm"
      question="Delete page"
      info="Are you sure?"
      primaryText="Yes"
      onPrimaryAction={onDelete}
      secondaryText="No"
      onSecondaryAction={goBack}
      showSpinner={loading}
    />
  );
};
